import * as msal from "@azure/msal-browser";

const msalConfig = {
    auth: {
        clientId: '84a9da45-1ca1-4295-bfb6-8e7be53ebc5e',
        // redirectUri: process.env.VUE_APP_URI,
    }
}

export default new msal.PublicClientApplication(msalConfig);